import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('MainWidget').create(({ theme }) => ({
  contentWrapper: {
    maxWidth: '100vw',
    height: '100vh',
    overflowY: 'scroll',
    overflowX: 'hidden',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: '14vh',
    gap: '12px',
    color: theme.colors.text.primary,
  },

  connectButton: {
    width: '100%',
    position: 'fixed',
    height: '52px',
    bottom: '10vh',
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    '&[data-connected="true"]': {
      display: 'none',
    },
  },

  cannotUpdateWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '0px',
  },

  untilUpdateWrapper: {
    display: 'flex',
    gap: '2px',
  },

  untilUpdateText: {
    fontSize: '11px',
    color: theme.colors.text.secondary,
    fontWeight: 350,
  },

  digit: {
    display: 'flex',
    minWidth: '15px',
  },

  timer: {
    display: 'flex',
    fontSize: '11px',
    color: theme.colors.text.secondary,
    fontWeight: 350,
  },

  updateNowWrapper: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },

  shareButtons: {
    width: '90%',
    minHeight: '70px',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    justifyContent: 'space-between',
  },

  joinCommunityButton: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 460,
    fontSize: '13px',
    textAlign: 'center',
    padding: '0px 8px',
    gap: '4px',
    position: 'relative',
    overflow: 'hidden',
    lineHeight: theme.sizes.texts.lineHeight.s,
  },

  shareLastButton: {
    width: '50%',
    color: 'white !important',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontWeight: 460,
    fontSize: '13px',
    textAlign: 'center',
    padding: '0px 4px',
    position: 'relative',
    overflow: 'hidden',
    lineHeight: theme.sizes.texts.lineHeight.s,
    gap: '2px',
    img: {
      maxHeight: '32px',
      aspectRatio: '1/1',
    },
  },

  updateText: {
    zIndex: '6',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '2px',
    p: {
      margin: '0px',
    },
    span: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '2px',
    },
  },

  topUpButton: {
    width: '33%',
    color: 'white !important',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontWeight: 460,
    fontSize: '13px',
    backgroundColor: 'rgba(176, 177, 184, 0.22)',
    lineHeight: theme.sizes.texts.lineHeight.s,
  },

  timerText: {
    textAlign: 'center',
    minWidth: '60px',
  },

  newsButton: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Inter',
    fontWeight: 460,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    color: 'white !important',
    border: `2px solid ${theme.colors.button.secondary.background}`,
    background: '#323233',
    padding: '0px',
    '&[data-glow="Ambassador Case"]': {
      background: 'linear-gradient(180deg, #2F3034 0%, #A335EE 100%)',
    },
    '&[data-glow="CARGO Case"]': {
      background: 'linear-gradient(180deg, #2F3034 0%, #4A6BFC 100%)',
    },
    '&[data-glow="Steam On! Case"]': {
      background: 'linear-gradient(180deg,#2F3034 0%, rgb(221, 207, 144) 100%)',
    },
    img: {
      width: '22px',
      aspectRatio: '1/1',
    },
  },

  dot: {
    color: theme.colors.text.success,
    padding: '0px',
  },

  balanceUpdateWrapper: {
    display: 'flex',
    width: '90%',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '16px 0px',
  },

  balanceTextWrapper: {
    display: 'flex',
    width: 'fit-content',
    flexDirection: 'column',
    gap: '4px',

    span: {
      fontSize: theme.sizes.texts.fontSize.m,
      fontWeight: 350,
      color: theme.colors.text.secondary,
    },
  },

  gigiTextWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '4px',
    cursor: 'pointer',
  },

  lastReward: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.text.secondary,
    fontSize: theme.sizes.texts.fontSize.s,
    fontWeight: '450',
    lineHeight: theme.sizes.texts.lineHeight.m,

    fontStyle: 'normal',
    gap: '5px',
    span: {
      color: theme.colors.text.primary,
    },
  },

  header: {
    position: 'relative',
    zIndex: '1',
  },

  title: {
    margin: '0',

    display: 'flex',
    alignSelf: 'center',
    width: '90%',
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    fontWeight: '370',
    color: theme.colors.text.secondary,
    textTransform: 'uppercase',
  },

  voidBg: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '90%',
    height: '295px',
    zIndex: '997',

    img: {
      width: '100%',
      height: '100%',
    },
  },
}))
